/**
 * Lo que la pantalla del simulador necesita de «la cuenta de la fuente»:
 * conectar, renovar y olvidar, y saber si hay app que pedir. Es una
 * interfaz y no el módulo MSAL a propósito: la vista no importa MSAL, así
 * que sus tests no tocan Entra (se le pasa una cuenta falsa) y la
 * aplicación real le pasa la de `msal.ts`.
 */
export interface SesionFuente {
  /** Access token delegado de Business Central. Vive SOLO en el estado de React. */
  token: string;
  /** El nombre de la cuenta conectada («MOD Administrator»). */
  cuenta: string;
}

export interface CuentaFuente {
  /** false si falta `VITE_SIMULADOR_CLIENT_ID`: Business Central se apaga con porqué. */
  configurada: boolean;
  /** Ventana de Microsoft con selector de cuenta: el permiso de solo lectura. */
  conectar(): Promise<SesionFuente>;
  /** Token nuevo tras `connection_expired`: en silencio si se puede, si no, la ventana. */
  renovar(): Promise<SesionFuente>;
  /** Desconectar: olvida la cuenta y el token de la memoria de MSAL. */
  olvidar(): Promise<void>;
}

/** El usuario cerró la ventana de Microsoft sin aceptar: no es un error que contar en rojo. */
export class ConexionCancelada extends Error {
  constructor() {
    super("conexión cancelada");
    this.name = "ConexionCancelada";
  }
}
